import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";
import TopBar from "./components/TopBar";
import firebase from "./firebase";
import NavigationDrawer from "./components/NavigationDrawer";
import { StripeProvider } from "react-stripe-elements";
import * as actions from "./actions/app.actions";

import "./App.css";
import withFirestorePath from "./components/withFirestorePath";
import { STRIPE_PK } from "./config";
import { messaging } from "firebase";
import notificationSound from "./sound/pristine.mp3";
const styles = (theme) => ({
  root: {
    display: "flex",
    alignItems: "stretch",
    minHeight: "100vh",
    width: "100%",
  },
  grow: {
    flex: "1 1 auto",
  },
  title: {
    marginLeft: 24,
    flex: "0 1 auto",
  },
  appBar: {
    transition: theme.transitions.create("width"),
    "@media print": {
      position: "absolute",
    },
  },
  appBarHome: {
    boxShadow: "none",
  },
  appBarShift: {
    [theme.breakpoints.up("lg")]: {
      width: "calc(100% - 250px)",
    },
  },
  drawer: {
    [theme.breakpoints.up("lg")]: {
      width: 250,
    },
  },
  navIconHide: {
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDrawer: false,
      drawerOpen: false,
      dockedDrawer: false,
      firebaseUser: null,
    };
  }

  handleDrawerTap = () => {
    this.setState({
      drawerOpen: !this.state.drawerOpen,
    });
  };

  updateDimensions = () => {
    const width = window.innerWidth;
    const isMobile = width < 768;
    const drawerOpen = !isMobile;
    const dockedDrawer = !isMobile;

    this.setState({
      showDrawer: !!this.state.firebaseUser && !!this.props.restaurantPath,
      drawerOpen,
      dockedDrawer,
      isMobile,
    });
  };

  async componentDidMount() {
    let restaurant;

    try {
      const restaurantSnap = await this.props.restaurantPath.get();
      restaurant = restaurantSnap.data();
      this.setState({
        title: restaurant && restaurant.name,
      });
      this.updateDimensions();
    } catch (e) {}

    this.unsubscribeAuthListener = firebase
      .auth()
      .onAuthStateChanged((firebaseUser) => {
        this.setState({
          firebaseUser,
        });
        this.updateDimensions();
      });

    const { group } = this.props.location.query;
    if (group) {
      this.props.setPriceGroup(group);
    }

    window.addEventListener("resize", this.updateDimensions);
    const fcmToken = await firebase.messaging().getToken();
    firebase.messaging().onTokenRefresh;
    firebase.messaging().onMessage(this.onNotificationReceived);
    console.log({ fcmToken });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const currentPathName = this.props.location && this.props.location.pathname;
    const previousPathName = prevProps.location && prevProps.location.pathname;
    if (currentPathName === previousPathName) return;

    this.updateDimensions();
  }

  onNotificationReceived(message) {
    console.log({ message });
    this.playNotificationSound();
  }

  playNotificationSound() {
    const audio = new Audio(notificationSound);
    var playedTimes = 0;
    audio.addEventListener("ended", () => {
      if (playedTimes < 5) {
        playedTimes++;

        audio.play();
      }
    });
    audio.play();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  onNavItemClicked = () => {
    if (this.state.dockedDrawer) return;

    this.setState({
      drawerOpen: false,
    });
  };

  render() {
    const {
      restaurantPath,
      params,
      classes,
      children,
      style,
      ...otherProps
    } = this.props;
    const restaurantId = params.restaurantId;

    const {
      title,
      showDrawer,
      drawerOpen,
      dockedDrawer,
      isMobile,
    } = this.state;

    const paddingLeft = showDrawer && drawerOpen && dockedDrawer ? 250 : 0;

    return (
      <StripeProvider apiKey={STRIPE_PK}>
        <div className="App" style={style}>
          <TopBar
            {...otherProps}
            handleDrawerTap={this.handleDrawerTap}
            title={title}
            hideDrawer={!showDrawer}
            restaurantId={restaurantId}
            isMobile={isMobile}
          />
          <div style={{ paddingLeft }}>
            {showDrawer ? (
              <NavigationDrawer
                containerStyle={{ marginTop: 65 }}
                onRequestChange={(drawerOpen) => this.setState({ drawerOpen })}
                docked={this.state.dockedDrawer}
                open={this.state.drawerOpen}
                restaurantId={restaurantId}
                onItemClicked={this.onNavItemClicked}
                menuDisabled={!restaurantId}
                restaurantPath={restaurantPath}
              />
            ) : (
              ""
            )}

            <div style={{ marginTop: 65 }}>{children}</div>
          </div>
        </div>
      </StripeProvider>
    );
  }
}

App.propTypes = {
  children: PropTypes.node.isRequired,
};

function mapDispatchToProps(state) {
  return {
    auth: state.auth,
  };
}

export default connect(mapDispatchToProps, actions)(withFirestorePath(App));



// WEBPACK FOOTER //
// ./src/App.js